module.exports = __webpack_public_path__ + "img/1.351179e0.png";